import React,  { PureComponent } from 'react'
import { Link, useParams } from 'react-router-dom'
import LayersIcon from '@mui/icons-material/Layers';
import { Divider, useTheme } from '@mui/material';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import PaymentIcon from '@mui/icons-material/Payment';
import useStore from '../utlis/customHooks/useStore';
import { ArrowDropDownSharp, SearchSharp } from '@mui/icons-material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import InsightsIcon from '@mui/icons-material/Insights';
import ListIcon from '@mui/icons-material/List';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import BarChartIcon from '@mui/icons-material/BarChart';
import RadarIcon from '@mui/icons-material/Radar';
// import List from '@mui/material/List';
// import ListItem from '@mui/material/ListItem';
// import ListItemText from '@mui/material/ListItemText';
// import ListItemAvatar from '@mui/material/ListItemAvatar';
// import Avatar from '@mui/material/Avatar';
// import ImageIcon from '@mui/icons-material/Image';
// import WorkIcon from '@mui/icons-material/Work';
// import BeachAccessIcon from '@mui/icons-material/BeachAccess';

// import { PieChart, Pie, Sector, Cell, ResponsiveContainer } from 'recharts';
import { VictoryLabel, VictoryPie} from 'victory';


const COLORS = ['#ef4444', '#22c55e'];

const RADIAN = Math.PI / 180;




export default function Instance(props) { 
    let {id} = useParams()
    let theme = useTheme()
    const {state, fetchMarketData, fetchData} = useStore()
    const [currentPage, setCurrentPage] = React.useState(1)
    const [startIndex, setStartIndex] = React.useState(0)
    const [endIndex, setEndIndex] = React.useState(9)
    const [searchedPair, setSearchedPair] = React.useState('')
    const [chartData, setChartData] = React.useState([

    ])


    React.useEffect(()=> {
      console.log(theme)
      if(state.firestore[id]) {
        let data = []
        data.push({
          "name" : "Winning Trades",
          "value" : calcPW(state.firestore[id].overall_stats)
        })
        data.push({
          "name" : "Losing Trades",
          "value" : calcPL(state.firestore[id].overall_stats)
        })
        setChartData(data)
      }
    }, [state.firestore[id]])

    // const calcpnlByPair = (data) => {
    //   let totalAmount = (data.winning_trades + data.losing_trades) * 100
    //   let amountLeft = (data.total_gain + data.total_loss) + (100 * (data.winning_trades + data.losing_trades))
    //   let pnl = (amountLeft - totalAmount)
    //   return Number(pnl).toFixed(2)
    // }

    // const calcTotalTrades = (data) => {
    //   return (data.winning_trades + data.losing_trades)
    // }

    const calcPW = (data) => {
        return (data.winning_trades / (data.winning_trades + data.losing_trades) * 100).toFixed(2)
    }

    const calcPL = (data) => {
        return (data.losing_trades / (data.winning_trades + data.losing_trades) * 100).toFixed(2)
    }

    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
      const radius = innerRadius + (outerRadius - innerRadius) * 0.25;
      const x = cx + radius * Math.cos(-midAngle * RADIAN);
      const y = cy + radius * Math.sin(-midAngle * RADIAN);

      return (
        <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
          {`${Number(state.firestore[id].analytics.total_trades * percent).toFixed(0)} (${Number(percent * 100).toFixed(2)} %)`}
        </text>
      );
    };

    const calcAvgWin = (data) => {
        if(data.winning_trades === 0) {
            return 0
        }
        return (data.total_gain / data.winning_trades).toFixed(2)
    }

    const calcAvgLoss = (data) => {
        if(data.losing_trades === 0) {
            return 0
        }
        return (data.total_loss / data.losing_trades).toFixed(2)
    }

    const calcAPPT = (data) => {
        let totalTrades = (data.winning_trades + data.losing_trades)
        if(totalTrades === 0) {
            return 0
        }
        let pw = data.winning_trades / totalTrades;
        let pl = data.losing_trades / totalTrades;
        let avg_win = data.total_gain /data.winning_trades;
        if(data.winning_trades === 0) {
            avg_win = 0
        }
        let avg_loss = Math.abs(data.total_loss) / data.losing_trades;
        if(data.losing_trades === 0) {
            avg_loss = 0
        }
        let appt = (pw * avg_win) - (pl * avg_loss)
        return Number(appt).toFixed(2) 
    }

    const handlePrevClick = () => {
      if(currentPage !== 1) {
        setCurrentPage(currentPage - 1)
        setStartIndex(startIndex - 10)
        setEndIndex(endIndex - 10)
      }
    }

    const handleNextClick = () => {
        setCurrentPage(currentPage + 1)
        setStartIndex(startIndex + 10)
        setEndIndex(endIndex + 10)
    }

    const getGainsPercents = () => {
        const account = parseFloat(state.firestore[id] ? state.firestore[id].account : 0)
        let pnl =  account - (state.firestore[id].opening_balance ? state.firestore[id].opening_balance : 10000)
        let pnlPercent = (pnl / (state.firestore[id].opening_balance ? state.firestore[id].opening_balance : 10000)) * 100
        return {
          pnl : Math.floor(parseFloat(pnl)),
          pnlPercent : Number(parseFloat(pnlPercent).toFixed(2))
        }
    }

    const portfolio = () => {
      return Math.floor(parseFloat(state.firestore[id] ? state.firestore[id].account : 0))
    }

    const parseUrl = (pair) => {
      let coin = pair.replaceAll("USDT", "")
      return `https://lcw.nyc3.cdn.digitaloceanspaces.com/production/currencies/64/${coin.toLowerCase()}.png`
    }

    const coin = (pair) => {
      return pair.replaceAll("USDT", "")
    }

    const currentValueByPair = (pair, price, quantity)=> {
      const currentValue = quantity * Number(price).toFixed(2)
      return Number(currentValue).toFixed(2)
    }
    const calcPnLPercent = (pair, price, quantity) => {
      const currentValue = quantity * Number(price).toFixed(2)

      return Number(currentValue - 100).toFixed(2)
    }

    const calcpnlByPair = (data) => {
      let totalAmount = (data.winning_trades + data.losing_trades) * 100
      let amountLeft = (data.total_gain + data.total_loss) + (100 * (data.winning_trades + data.losing_trades))
      let pnl = (amountLeft - totalAmount)
      return Number(pnl).toFixed(2)
    }

    const calcTotalTrades = (data) => {
      return (data.winning_trades + data.losing_trades)
    }

    React.useEffect(()=> {
      let pairs = []
      if(state.firestore[id]) {
        Object.keys(state.firestore[id].asset_table).map( key => {
          pairs.push(`${key.toLowerCase()}@aggTrade`)
        })

        console.log(pairs)
        fetchMarketData(pairs)
      }
      if(!state.firestore[id]) {
        fetchData()
      }
    }, [])

    const search = (pair)=> {
      if(searchedPair.length <= 2) {
        return true
      }

      if(pair.toLowerCase().includes(searchedPair.toLowerCase())) {
        return true
      }

      else {
        return false
      }
    }

    const filter = (first, second)=> {
      return 1;
    }

    return (<>
      {state.firestore && state.firestore[id] && !state.loading && <div className="md:mx-20">
          <div className="flex flex-row px-5">
              <div className="bg-blue-100 dark:bg-gray-900 p-2 rounded-lg mr-5">
                  <LayersIcon className="text-blue-500" sx={{fontSize : {
                    xs : '2.5em',
                    md: '4em'
                  }}} />
              </div>
              <div className="flex flex-col overflow-auto">
                  <span className="text-base md:text-3xl">Instance 
                    <span className="mx-3 text-xs md:text-base font-light dark:bg-gray-800 px-2 py-1 rounded bg-blue-100 text-blue-500 dark:text-gray-100">
                      {id.substring(0,8)}
                    </span>
                  </span>
                  <div className="flex flex-row text-gray-500 dark:text-white mt-1">
                  <span className="text-sm md:text-base"> 
                      {state.firestore[id].instance_type === 'HISTORIC' ? (<>
                            {/* <span><FiberManualRecordIcon className="text-yellow-200" style={{fontSize : '1.2em', marginTop : '-2px'}}/> </span> */}
                            <span className="text-sm md:text-base">Historic</span>
                        </>
                        ): (<>
                            {/* <span><FiberManualRecordIcon className="text-green-600" style={{fontSize : '1.2em', marginTop : '-2px'}}/> </span> */}
                            <span className="text-sm md:text-base">Live</span>
                            </>
                        )}
                  </span>
                      <span className="mx-1">•</span>
                      <span className="text-sm md:text-base">${(state.firestore[id].analytics.total_trades) * 100} Traded</span>         
                  </div>
              </div>
          </div>

          <div className="my-5">
              <Divider horizontal />
          </div>

          <div className="flex flex-row justify-center px-5">
              <div className="w-full md:w-44 flex flex-col px-4 pt-2 pb-3 mx-2 my-1  dark:bg-gray-900 rounded-lg text-left ring-1 ring-gray-200 dark:ring-0 dark:ring-gray-800">
                  <span className="text-blue-500 dark:text-gray-300 text-xs md:text-base  mb-1 mt-1 capitalize"> <PaymentIcon sx={{fontSize : '1.4em', marginTop : '-2px', marginRight : '2px'}}/> Total P & L</span>
                  {getGainsPercents().pnl > 0 && <span className="flex flex-row text-sm md:text-base"> 
                      <span className="text-green-600 -mx-2" style={{marginTop : '-2px'}}> <ArrowDropUpIcon /> </span>
                      <span className="text-green-600 mx-2"> $ {getGainsPercents().pnl}</span>

                  </span>}
                  {getGainsPercents().pnl == 0 && <span className="flex flex-row text-sm md:text-base"> 
                    <span className="text-gray-600 -mx-2" style={{marginTop : '-2px'}}> <ArrowDropUpIcon /> </span>
                    <span className="text-gray-600 mx-2"> $ {getGainsPercents().pnl}</span>
                    
                </span>}

                {getGainsPercents().pnl < 0 && <span className="flex flex-row text-sm md:text-base"> 
                    <span className="text-red-600 -mx-2" style={{marginTop : '-2px'}}> <ArrowDropDownSharp/> </span>
                    <span className="text-red-600 mx-2"> $ {getGainsPercents().pnl}</span>
                    
                      
                </span>}
                    
              </div>
              <div className="flex flex-col px-4 pt-2 pb-3 mx-2 my-1  dark:bg-gray-900 rounded-lg text-left ring-1 ring-gray-200 dark:ring-gray-800">
              <span className="text-blue-500 dark:text-gray-300 text-xs md:text-base mb-1 mt-1 capitalize"> <InsightsIcon sx={{fontSize : '1.4em', marginTop : '-2px', marginRight : '2px'}}/> PORTFOLIO</span>
                  {getGainsPercents().pnl > 0 && <span className="flex flex-row text-center text-sm md:text-base">
                      <span className="text-green-600 -mx-2" style={{marginTop : '-2px'}}><ArrowDropUpIcon/></span>
                      <span className="text-green-600 mx-2"> ${ portfolio()}</span>
                      <span className=" text-green-600"> ({getGainsPercents().pnlPercent}%) </span>
                  </span>}
                  {getGainsPercents().pnl < 0 && <span className="flex flex-row text-center text-sm md:text-base">
                    <span className="text-red-600 -mx-2" style={{marginTop : '-2px'}}><ArrowDropDownSharp/></span>
                    <span className="text-red-600 mx-2"> ${ portfolio()}</span>
                    <span className=" text-gray-600"> ({getGainsPercents().pnlPercent}%) </span>
                </span>}

                {getGainsPercents().pnl == 0 && <span className="flex flex-row text-center text-sm md:text-base">
                    <span className="text-gray-600 -mx-2" style={{marginTop : '-2px'}}><ArrowDropUpIcon/></span>
                    <span className="text-gray-600 mx-2"> ${ portfolio()}</span>
                    <span className=" text-red-600"> ({getGainsPercents().pnlPercent}%) </span>
                </span>}
                    
              </div>
          </div>

          {state.firestore[id].strategy_details && <div className="my-8 pl-5">
            <div className="mb-2 font-sans font-semibold"> Instance
              <span className="mx-3 text-xs md:text-sm font-light dark:bg-gray-800 px-2 py-1 rounded bg-blue-100 text-blue-500 dark:text-gray-100">
                {id.substring(0,8)}
              </span>
            </div>
            <div className="grid grid-cols-12 gap-5 w-full mt-5 pl-3">
              <div className="col-span-12 grid grid-cols-12">
                <div className="col-span-2 my-auto">
                  <AccessTimeFilledIcon className="text-blue-500"/>
                </div>
                <div className="col-span-10">
                  <div className="flex flex-col justify-center">
                    <span className="text-base">{state.firestore[id].instance_period}</span>
                    <span className="text-xs text-gray-500">Time Period</span>
                  </div>
                </div>
              </div>

              <div className="col-span-6 grid grid-cols-12 ">
                <div className="col-span-3 my-auto ">
                  <BarChartIcon className="text-blue-500"/>
                </div>
                <div className="col-span-9">
                  <div className="flex flex-col justify-center">
                    <span className="text-base">{state.firestore[id].instance_interval.toUpperCase()}</span>
                    <span className="text-xs text-gray-500">Candle Chart</span>
                  </div>
                </div>
              </div>

              <div className="col-span-6 grid grid-cols-12">
                <div className="col-span-3 my-auto">
                  <LocalAtmIcon className="text-blue-500"/>
                </div>
                <div className="col-span-9">
                  <div className="flex flex-col justify-center">
                    <span className="text-base">$ {state.firestore[id].opening_balance}</span>
                    <span className="text-xs text-gray-500">Opening Balance</span>
                  </div>
                </div>
              </div>

              <div className="col-span-6 grid grid-cols-12">
                <div className="col-span-3 my-auto">
                  <LayersIcon className="text-blue-500"/>
                </div>
                <div className="col-span-9">
                  <div className="flex flex-col justify-center ">
                    <span className="text-base">{state.firestore[id].instance_type === 'HISTORIC' ? 'Historic' : 'Live'}</span>
                    <span className="text-xs text-gray-500">Instance Type</span>
                  </div>
                </div>
              </div>

              <div className="col-span-6 grid grid-cols-12">
                <div className="col-span-3 my-auto">
                  <RadarIcon className="text-blue-500"/>
                </div>
                <div className="col-span-9">
                  <div className="flex flex-col justify-center ">
                    <span className="text-base">{state.firestore[id].analytics.total_trades}</span>
                    <span className="text-xs text-gray-500">Trades Executed</span>
                  </div>
                </div>
              </div>

            </div>
          </div>}


          <div>
          {/* <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
              <ListItem>
                <ListItemAvatar>
                  <Avatar>
                    <ImageIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary="Trades" secondary={<>
                  <div className="grid grid-cols-12 space-x-4 mb-4">
                      <span className="col-span-6 flex flex-col justify-center text-center border rounded dark:border-gray-700 px-2 py-1 w-28">
                          <span className="text-gray-600 text-xs">
                              Winning Trades
                          </span>
                          <span className={`text-center ${state.firestore[id].overall_stats.winning_trades > 0 ? 'text-green-500' : ''}`}>
                              {state.firestore[id].overall_stats.winning_trades}
                          </span>
                      </span>

                      <span className="col-span-6 flex flex-col justify-center text-center border rounded dark:border-gray-700 px-2 py-1 w-28">
                          <span className="text-gray-600 text-xs">
                              Total Gains
                          </span>
                          <span className={`text-center ${Number(state.firestore[id].overall_stats.total_gain).toFixed(2) > 0.00 ? 'text-green-500' : ''}`}>
                             $ {Number(state.firestore[id].overall_stats.total_gain).toFixed(2)}
                          </span>
                      </span>

                  </div>
                </>

                } />
              </ListItem>
              <ListItem>
                <ListItemAvatar>
                  <Avatar>
                    <WorkIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary="Work" secondary="Jan 7, 2014" />
              </ListItem>
              <ListItem>
                <ListItemAvatar>
                  <Avatar>
                    <BeachAccessIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary="Vacation" secondary="July 20, 2014" />
              </ListItem>
            </List> */}
          </div>
          <div className="my-3 mx-5">
              <span className="mb-2 font-sans font-semibold">Trade Statistics</span>
          </div>
          <div className="mt-5 flex flex-row justify-center h-36">
          <VictoryPie
              data={[
                { x: state.firestore[id].overall_stats.winning_trades , y: Math.abs(calcPL(state.firestore[id].overall_stats)), label : `${state.firestore[id].overall_stats.losing_trades} Trades \n  ${ Math.abs(calcPL(state.firestore[id].overall_stats))}%` },
                { x: state.firestore[id].overall_stats.losing_trades, y: Math.abs(calcPW(state.firestore[id].overall_stats)), label : `${state.firestore[id].overall_stats.winning_trades}  Trades \n ${Math.abs(calcPW(state.firestore[id].overall_stats))}%` },
              ]}
              labels={({ datum }) => `${datum.label} / ${datum.y}%`}
              colorScale={["#f44336", "#4caf50"]}
              animate={{
                duration: 500,
                onLoad: { duration: 500 }
              }}
              labelComponent={
                <VictoryLabel
                tabIndex={0}
                lineHeight={[1, 2]}
                y={60}
                  style={[
                    { fill: theme.palette.type === 'dark' ? "white" : 'gray', fontSize: 36, fontFamily: "monospace" },
                    { fill: theme.palette.type === 'dark' ? "white" : 'gray', fontSize: 36, fontWeight: 'bold', fontFamily: "monospace"},
                  ]}
                />
              }
            />
          </div>
          <div className="flex flex-row justify-center text-xs text-gray-500 mb-3 font-mono">
            Trades By Profit/Loss
          </div>
          <div className="flex flex-row space-x-5 justify-center text-xs">
            <div className="flex flex-row space-x-2">
              <div className="w-3 h-3 bg-green-500 mt-1">

              </div>
              <div style={{marginTop : '1px'}}>
                Profitable Trades
              </div>
            </div>

            <div className="flex flex-row space-x-2">
              <div className="w-3 h-3 bg-red-500 mt-1">

              </div>
              <div style={{marginTop : '1px'}}>
                Loss Trades
              </div>
            </div>
          </div>
          <div className="p-1 flex flex-row flex-wrap my-4 justify-center">
              <div className="grid grid-cols-12 space-x-4 mb-4">
                  <span className="col-span-6 flex flex-col justify-center text-center border rounded dark:border-gray-700 dark:bg-gray-900 px-2 py-1 w-28">
                      <span className="text-gray-600 text-xs">
                          APPT
                      </span>
                      <span className={`text-center ${calcAPPT(state.firestore[id].overall_stats) > 0.00 ? 'text-green-500' : 'text-red-500'}`}>
                         $ {calcAPPT(state.firestore[id].overall_stats)}
                      </span>
                  </span>

                  <span className="col-span-6 flex flex-col justify-center text-center border rounded dark:border-gray-700 dark:bg-gray-900 px-2 py-1 w-28">
                      <span className="text-gray-600 text-xs">
                          Total Gains
                      </span>
                      <span className={`text-center ${Number(state.firestore[id].overall_stats.total_gain).toFixed(2) > 0.00 ? 'text-green-500' : ''}`}>
                         $ {Number(state.firestore[id].overall_stats.total_gain).toFixed(2)}
                      </span>
                  </span>

              </div>

              <div className="grid grid-cols-12 space-x-4">
                  <span className="col-span-6 flex flex-col justify-center text-center border rounded dark:border-gray-700 dark:bg-gray-900 px-2 py-1 w-28">
                      <span className="text-gray-600 text-xs">
                          Total Trades
                      </span>
                      <span className={`text-center`}>
                          {state.firestore[id].overall_stats.losing_trades  + state.firestore[id].overall_stats.winning_trades}
                      </span>
                  </span>

                  <span className="col-span-6  flex flex-col justify-center text-center border rounded dark:border-gray-700 dark:bg-gray-900 px-2 py-1 w-28">
                      <span className="text-gray-600 text-xs">
                          Total Losses
                      </span>
                      <span className={`text-center ${Number(state.firestore[id].overall_stats.total_loss).toFixed(2) !== 0.00 ? 'text-red-500' : ''}`}>
                          ${Number(state.firestore[id].overall_stats.total_loss).toFixed(2)}
                      </span>
                  </span>
              </div>

              <div className="grid grid-cols-12 space-x-4 my-4">
                <span className="col-span-6 flex flex-col justify-center text-center border rounded dark:border-gray-700 dark:bg-gray-900 px-2 py-1 w-28">
                    <span className="text-gray-600 text-xs">
                        Avg.(Win)
                    </span>
                    <span className={`text-center ${calcAvgWin(state.firestore[id].overall_stats) === 0.00 ? '' : 'text-green-500'}`}>
                        $ {calcAvgWin(state.firestore[id].overall_stats)}
                    </span>
                </span>

                <span className="col-span-6  flex flex-col justify-center text-center border rounded dark:bg-gray-900 dark:border-gray-700 px-2 py-1 w-28">
                    <span className="text-gray-600 text-xs">
                        Avg.(Loss)
                    </span>
                    <span className={`text-center ${calcAvgLoss(state.firestore[id].overall_stats) === 0.00 ? '' : 'text-red-500'}`}>
                        $ {calcAvgLoss(state.firestore[id].overall_stats)}
                    </span>
                </span>
            </div>
          </div>
          
          {Object.keys(state.firestore[id].asset_table).length > 0 && <div className="my-8">
              <div className="mb-2 font-sans font-semibold px-5">
                  Asset Table
              </div>
              <div className=" grid grid-cols-2">
                  <p className="text-left text-sm text-gray-500">{Object.keys(state.firestore[id].asset_table).length} Holdings</p>
                  <p className="text-right text-sm text-gray-500">$ 10000 Invested</p>
              </div>
              <div className="flex flex-col">
                <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div className="shadow overflow-hidden border-b border-gray-200 dark:border-gray-800 rounded-lg my-5">
                      <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 rounded-md">
                        <thead className="bg-gray-50 dark:bg-gray-800">
                          <tr>
                            <th
                              scope="col"
                              className="px-6 py-3 text-left text-xs font-medium text-gray-500  uppercase tracking-wider"
                            >
                              Coin
                            </th>
                            <th
                              scope="col"
                              className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            >
                              P & L
                            </th>
                            {/* <th
                              scope="col"
                              className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            >
                              Title
                            </th>
                            <th
                              scope="col"
                              className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            >
                              Status
                            </th>
                            <th
                              scope="col"
                              className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            >
                              Role
                            </th>
                            <th scope="col" className="relative px-6 py-3">
                              <span className="sr-only">Edit</span>
                            </th> */}
                          </tr>
                        </thead>
                        <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200">
                          {Object.keys(state.firestore[id].asset_table).map((key) => (
                            <tr key={key}>
                              <td className="px-6 py-4 whitespace-nowrap">
                                <div className="flex items-center">
                                  <div className="flex-shrink-0 h-10 w-10">
                                    <img className="h-10 w-10 rounded-full" src={parseUrl(key)} alt="" />
                                  </div>
                                  <div className="ml-4">
                                    <div className="text-sm font-medium text-gray-900 dark:text-white">{Number((state.firestore[id].asset_table[key])).toFixed(7)}</div>
                                    <div className="text-sm text-gray-500">{key}</div>
                                  </div>
                                </div>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap">
                                <div className="flex items-center">
                                  <div className="ml-4">
                                    {state.marketData[key] && calcPnLPercent(key, state.marketData[key], state.firestore[id].asset_table[key] ) > 0  && <div className="text-sm font-medium text-green-600">{calcPnLPercent(key, state.marketData[key], state.firestore[id].asset_table[key] ) } %</div>}
                                    {state.marketData[key] && calcPnLPercent(key, state.marketData[key], state.firestore[id].asset_table[key] ) < 0  && <div className="text-sm font-medium text-red-600">{calcPnLPercent(key, state.marketData[key], state.firestore[id].asset_table[key] ) } %</div>}
                                    {state.marketData[key] && calcPnLPercent(key, state.marketData[key], state.firestore[id].asset_table[key] ) == 0  && <div className="text-sm font-medium text-gray-600">{calcPnLPercent(key, state.marketData[key], state.firestore[id].asset_table[key] ) } %</div>}
                                    <div className="text-sm text-gray-500">$ {state.marketData[key] ? currentValueByPair(key, state.marketData[key], state.firestore[id].asset_table[key]) : '-'}</div>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))}

                          {Object.keys(state.firestore[id].asset_table).length === 0 && (
                            <tr>
                              <td className="px-6 py-4 whitespace-nowrap">
                                -
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-center">
                                -
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
          </div>}

        {Object.keys(state.firestore[id].stop_loss_table).length > 0 && <div className="my-8">
            <div className="mb-2 font-sans font-semibold px-5">
                Current Orders
            </div>
            <div className="flex flex-col">
              <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                  <div className="shadow overflow-hidden border-b border-gray-200 dark:border-gray-800 rounded-lg my-5">
                    <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 rounded-md">
                      <thead className="bg-gray-50 dark:bg-gray-800">
                        <tr>
                          <th
                            scope="col"
                            className="px-6 py-3 text-left text-xs font-medium text-gray-500  uppercase tracking-wider"
                          >
                            Coin
                          </th>
                          <th
                            scope="col"
                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          > 
                            Current/SL Price
                          </th>
                          {/* <th
                            scope="col"
                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            Title
                          </th>
                          <th
                            scope="col"
                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            Status
                          </th>
                          <th
                            scope="col"
                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            Role
                          </th>
                          <th scope="col" className="relative px-6 py-3">
                            <span className="sr-only">Edit</span>
                          </th> */}
                        </tr>
                      </thead>
                      <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200">
                      {Object.keys(state.firestore[id].stop_loss_table).map((key) => (
                          <tr key={key}>
                            <td className="px-6 py-4 whitespace-nowrap">
                              <div className="flex items-center">
                                <div className="flex-shrink-0 h-10 w-10">
                                  <img className="h-10 w-10 rounded-full" src={parseUrl(key)} alt="" />
                                </div>
                                <div className="ml-4">
                                  <div className="text-sm font-medium text-gray-900 dark:text-white">{Number((state.firestore[id].asset_table[key])).toFixed(7)}</div>
                                  <div className="text-sm text-gray-500">{key}</div>
                                </div>
                              </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                              <div className="flex items-center">
                                <div className="ml-4">
                                  <div className="text-sm font-medium text-yellow-600">$ {state.marketData[key] ? state.marketData[key] : (key)} </div>
                                  <div className="text-sm text-gray-500">{Number((state.firestore[id].stop_loss_table[key])).toFixed(7)}</div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ))}
                        {Object.keys(state.firestore[id].stop_loss_table).length === 0 && (
                          <tr>
                            <td className="px-6 py-4 whitespace-nowrap">
                              -
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-center">
                              -
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
        </div>}


        {state.firestore[id].strategy_details && <div className="mt-5 mb-10 pl-5">
            <div className="mb-2 font-sans font-semibold"> Strategy Details</div>
            <div className="grid grid-cols-12 gap-5 w-full mt-5 pl-3">
              <div className="col-span-6 grid grid-cols-12">
                <div className="col-span-3 my-auto">
                  <InsightsIcon className="text-blue-500"/>
                </div>
                <div className="col-span-9">
                  <div className="flex flex-col justify-center">
                    <span className="text-base">{state.firestore[id].strategy_details.name}</span>
                    <span className="text-xs text-gray-500">Strategy Type</span>
                  </div>
                </div>
              </div>

              <div className="col-span-6 grid grid-cols-12 ">
                <div className="col-span-3 my-auto ">
                  <ListIcon className="text-blue-500"/>
                </div>
                <div className="col-span-9">
                  <div className="flex flex-col justify-center">
                    <span className="text-base">{state.firestore[id].strategy_details.stop_loss_percent}%</span>
                    <span className="text-xs text-gray-500">Stop Loss</span>
                  </div>
                </div>
              </div>

              <div className="col-span-6 grid grid-cols-12">
                <div className="col-span-3 my-auto">
                  <ListIcon className="text-blue-500"/>
                </div>
                <div className="col-span-9">
                  <div className="flex flex-col justify-center">
                    <span className="text-base">{state.firestore[id].strategy_details.trigger_percent}%</span>
                    <span className="text-xs text-gray-500">Trigger</span>
                  </div>
                </div>
              </div>

              <div className="col-span-6 grid grid-cols-12">
                <div className="col-span-3 my-auto">
                  <ListIcon className="text-blue-500"/>
                </div>
                <div className="col-span-9">
                  <div className="flex flex-col justify-center">
                    <span className="text-base">{state.firestore[id].strategy_details.trailing_stop_loss_percent}%</span>
                    <span className="text-xs text-gray-500">Traling SL</span>
                  </div>
                </div>
              </div>

            </div>
          </div>}

          

        {state.firestore[id].analytics && <div className="my-8 px-5">
          <div className="mb-2 font-sans font-semibold  ">Profit Breakdown
          <span className="mx-3 text-xs font-light dark:bg-gray-800 px-2 py-1 rounded bg-blue-100 text-blue-500 dark:text-gray-100">
              By Coin
            </span>
          </div>
          <div className="relative mt-5">
            <SearchSharp className="absolute w-6 h-6 text-gray-500 dark:text-white my-1 ml-1" style={{fontSize : '1.4em'}} />
            <input 
            type="search"
            placeholder="Search Coin"
            className="px-8 py-1 placeholder-gray-400 text-sm bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-white focus:outline-none focus:shadow-outline border border-gray-300 dark:border-gray-600 rounded-lg"
            value={searchedPair} 
            onChange={(e)=> {
              setSearchedPair(e.target.value)
            }} 
            />
          </div>
          <div className="flex flex-row flex-nowrap overflow-contain FixedHeightContainer">
            {Object.keys(state.firestore[id].analytics.coins).filter(search).sort(filter).map((key) => (
            <Link to={`/instances/${id}/coins/${key}`} className="relative mx-2 my-5 flex flex-col justify-center text-center ring-1 ring-gray-200 rounded-md p-5 shadow-none dark:ring-gray-700">
            <div className="h-10 w-10 mx-auto mb-3">
              <img className="h-10 w-10 rounded-full" src={parseUrl(key)} alt="" />
            </div>
            <span>
            {calcpnlByPair(state.firestore[id].analytics.coins[key]) > 0 && <span className="flex flex-row "> 
                    <span className="text-green-600 -mx-1 text-sm" style={{marginTop : '-2px'}}> <ArrowDropUpIcon /> </span>
                    <span className="text-sm text-green-600"> ({calcpnlByPair(state.firestore[id].analytics.coins[key])}%) </span>
                </span>}

            {calcpnlByPair(state.firestore[id].analytics.coins[key]) == 0 && <span className="flex flex-row "> 
                  <span className="text-gray-600 -mx-1 text-sm" style={{marginTop : '-2px'}}> <ArrowDropUpIcon /> </span>
                  <span className="text-sm text-gray-600"> ({calcpnlByPair(state.firestore[id].analytics.coins[key])}%) </span>
              </span>}

              {calcpnlByPair(state.firestore[id].analytics.coins[key]) < 0 && <span className="flex flex-row "> 
                  <span className="text-red-600 -mx-1 text-sm" style={{marginTop : '-2px'}}> <ArrowDropDownSharp/> </span>
                  <span className="text-sm text-red-600"> ({calcpnlByPair(state.firestore[id].analytics.coins[key])}%) </span>   
              </span>}

            </span>
            <span><span className="text-xs">{key}</span></span>
            <span className="text-sm text-gray-400 mb-5">{calcTotalTrades(state.firestore[id].analytics.coins[key])} Trades</span>
            {/* <span className="text-sm text-gray-400 absolute bottom-0 left-0 m-2"> {store.state.firestore[key].instance_type === 'HISTORIC' ? (<>
                <span><FiberManualRecordIcon className="text-gray-200" style={{fontSize : '1em'}}/> </span>
                <span className="text-xs">Historic</span>
            </>
            ): (<>
                <span><FiberManualRecordIcon className="text-green-600" style={{fontSize : '1em'}}/> </span>
                <span className="text-xs">Live</span>
                </>
            )}
            </span> */}
            <div className="absolute bottom-0 right-0 m-2">
                <span className="text-sm mt-3 text-green-600 dark:text-gray-500"><ArrowForwardIcon style={{fontSize : '1.3em', marginLeft : '3px'}}/></span>
            </div>
        </Link>
            ))}
          </div> 
        </div>}




        <div className="my-12">
            <div className="mb-2 font-sans font-semibold  px-5">
              <span>Order History</span> 
              <span className=" mx-3 text-xs font-light dark:bg-gray-800 px-2 py-1 rounded bg-blue-100 text-blue-500 dark:text-gray-100">{Object.keys(state.firestore[id].orders).length} Orders!</span>
            </div>
            <div className="flex flex-col w-11/12 mx-auto">
              <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                  <div className="shadow overflow-hidden border-b border-gray-200 dark:border-gray-800 rounded-lg my-5">
                    <table className="divide-y divide-gray-200 dark:divide-gray-700 rounded-md">
                      <thead className="bg-gray-50 dark:bg-gray-900">
                        <tr>
                          <th
                            scope="col"
                            className="px-6 py-3 text-left text-xs font-medium text-gray-500  uppercase tracking-wider"
                          >
                            Coin
                          </th>
                          <th
                            scope="col"
                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          > 
                            Quantity/ Buy Price
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white dark:bg-gray-900 divide-y dark:divide-gray-800 divide-gray-200">
                        {Object.keys(state.firestore[id].orders).slice(startIndex, endIndex).map((key) => (
                          <tr key={key}>
                            <td className="px-6 py-4 whitespace-nowrap">
                              <div className="flex items-center">
                                <div className="flex-shrink-0 h-10 w-10">
                                  <img className="h-10 w-10 rounded-full" src={parseUrl(state.firestore[id].orders[key].pair)} alt="" />
                                </div>
                                <div className="ml-4">
                                  {state.firestore[id].orders[key].order_type === 'BUY' && <div className="text-sm font-medium text-green-600">BUY</div>}
                                  {state.firestore[id].orders[key].order_type === 'SELL' && <div className="text-sm font-medium text-red-600">SELL</div>}
                                  <div className="text-sm text-gray-500">{state.firestore[id].orders[key].pair}</div>
                                </div>
                              </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                              <div className="flex items-center">
                                <div className="ml-4">
                                  {state.firestore[id].orders[key].pnl === 0 && <span className="text-gray-500 text-sm"> {Number((state.firestore[id].orders[key].quantity)).toFixed(7)}</span>}
                                  {state.firestore[id].orders[key].pnl > 0.00 && <span className="text-green-500 text-sm">
                                    {Number(state.firestore[id].orders[key].pnl).toFixed(2)} %
                                  </span>}

                                  {state.firestore[id].orders[key].pnl < 0.00 && <span className="text-red-500 text-sm">
                                    {Number(state.firestore[id].orders[key].pnl).toFixed(2)} %
                                  </span>}

                                  <div className="text-sm text-gray-500">$ {Number((state.firestore[id].orders[key].price)).toFixed(2)}</div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ))}

                        {Object.keys(state.firestore[id].orders).length === 0 && (
                          <tr>
                            <td className="px-6 py-4 whitespace-nowrap">
                              -
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-center">
                              -
                            </td>
                          </tr>
                        )}
                      </tbody>

                    </table>
                    <div class="flex justify-center space-x-1  w-100 dark:bg-gray-900">
                        <div onClick={handlePrevClick} class="items-center px-4 py-1 text-gray-500 bg-gray-300 dark:bg-gray-900 rounded-md flex flex-row">
                            <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 17l-5-5m0 0l5-5m-5 5h12" />
                            </svg>
                            Prev
                        </div>
                        <div className="items-center px-4 py-1 text-gray-500 bg-gray-300 dark:bg-gray-900 rounded-md flex flex-row">{currentPage}</div>
                        <div onClick={handleNextClick} class="px-4 py-1 text-gray-500 bg-gray-300 dark:bg-gray-900 rounded-md hover:bg-blue-400 hover:text-white flex flex-row">
                          Next
                            <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                            </svg>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>


      </div>}
    </>
    )
}
